import { IUSERAUTHENTICATIONSERVICE_TOKEN } from './interfaces/IUserAuthenticationService.interface';
import { IUSERAUTHSTATESERVICE_TOKEN } from './interfaces/IUserAuthStateService.interface';
import { UserAuthenticationService } from './testUserAuthenticationService/UserAuthenticationService.service';
import { UserAuthStateService } from './userAuthState/UserAuthState.service';

export const DEFAULT_USER_AUTH_SERVICE_PROVIDER_ENTRY = { provide: IUSERAUTHENTICATIONSERVICE_TOKEN, useClass: UserAuthenticationService, multi: false };
export const DEFAULT_USER_AUTH_STATE_SERVICE_PROVIDER_ENTRY = { provide: IUSERAUTHSTATESERVICE_TOKEN, useClass: UserAuthStateService, multi: false };

export const DEFAULT_USER_AUTHENTICATION_PROVIDER_ENTRIES = [
        DEFAULT_USER_AUTH_SERVICE_PROVIDER_ENTRY,
        DEFAULT_USER_AUTH_STATE_SERVICE_PROVIDER_ENTRY,
]